<template>
  <BaseModal
    :open="show"
    title="Ketentuan Privasi Akun"
    size="lg"
    @close="$emit('Saya Mengerti')"
  >
    <div class="space-y-4 text-justify">
      <h1
        ref="agenda-preview-title"
        class="mb-4 text-xl font-medium leading-8 text-green-700 font-roboto"
        data-cy="agenda-preview__title"
      >
        Pelajari Lebih Lanjut Tentang Akun Anda
      </h1>
      <p>Akun Kontributor adalah akun dengan peran khusus untuk menambahkan dan memperbaharui konten di dalam sistem.</p>
      <ul class="list-disc list-inside space-y-2">
        Dengan akun ini, anda dapat: <br>
        <li>Mengubah konten: artikel, data, gambar, atau informasi lain sesuai kategori.</li>
        <li>Mengedit dan memperbaharui: memastikan konten yang sudah ada tetap akurat dan relevan.</li>
        <li>Berkolaborasi: bekerja sama dengan admin dan anggota lain untuk menjaga kualitas konten.</li>
      </ul>
      <ul class="list-disc list-inside space-y-2">
        Namun, Akun Kontributor memiliki batasan: <br>
        <li>Tidak dapat menghapus akun pengguna lain.</li>
        <li>Tidak memiliki akses penuh ke pengaturan sistem</li>
        <li>Perubahan konten tertentu mungkin memerlukan persetujuan Admin</li>
      </ul>
    </div>
    <template #footer>
      <div class="w-full h-full flex items-center justify-center">
        <BaseButton
          class="h-[38px] px-4 flex items-center rounded-lg border whitespace-nowrap font-bold disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-600 disabled:border-gray-300 bg-green-700 hover:bg-green-600 text-sm text-white"
          data-cy="modal-footer__close-button"
          @click="$emit('close')"
        >
          Saya Mengerti
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/common/components/BaseModal';
import BaseButton from '@/common/components/BaseButton';

export default {
  name: 'PreviewYourAccountModerator',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
